// extracted by mini-css-extract-plugin
module.exports = {"addAssociationButton":"addAssociationButton_addAssociationButton__1WUvO","fitContent":"addAssociationButton_fitContent__kviq2"};